export const getTelegramLink = (nickname: string): string => {
  return `https://t.me/${nickname.slice(1)}`;
};
